module.exports = __webpack_public_path__ + "static/img/banner.fde881a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner.jpeg
// module id = pT6u
// module chunks = 52